import request from '@/router/axios'

const API = '/api/produce/kanban/annual-indicators'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function normalize(d) {
  if (!d || typeof d !== 'object') {
    return { totalPlan: 0, totalActual: 0, items: [] }
  }
  return {
    totalPlan: n(d.totalPlan),
    totalActual: n(d.totalActual),
    items: (d.items || []).map((it) => ({
      name: it.name,
      plan: n(it.plan),
      actual: n(it.actual),
      yoyRate: it.yoyRate != null && it.yoyRate !== '' ? n(it.yoyRate) : null
    }))
  }
}

export function fetchAnnualIndicators(params = {}) {
  const body = {
    year: params.year != null ? parseInt(String(params.year), 10) : undefined,
    dimension: params.dimension || 'transport'
  }
  return request({
    url: API,
    method: 'post',
    data: body
  })
    .then(unwrap)
    .then(normalize)
}
